/**
 * Model danych akceptacji RODO (GDPR Legal Snapshot).
 * Obiekt ten jest generowany w momencie, gdy administrator klienta B2B
 * klika przycisk "Akceptuję umowę powierzenia przetwarzania danych osobowych".
 * Przechowuje zamrożony stan danych rejestrowych firmy z tamtej chwili.
 */
export class GdrpAcceptanceData {

  /** Ulica i numer budynku/lokalu siedziby firmy w momencie akceptacji. */
  public streetWithNumber: string;

  /** Miasto siedziby firmy. */
  public city: string;

  /** Kod pocztowy. */
  public postalCode: string;

  /** Pełna nazwa podmiotu gospodarczego. */
  public name: string;

  /** Numer Identyfikacji Podatkowej (NIP). */
  public taxId: string;

  /** Numer w rejestrze REGON. */
  public regon: string;

  /** Numer w Krajowym Rejestrze Sądowym. */
  public krs: string;

  /** Data i czas technicznego zarejestrowania akceptacji w systemie (Timestamp).
   */
  public acceptanceDate: string;

  /** Data formalnego podpisania umowy.
   */
  public signingDate: string;
}
